import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import DiggingGame from './DiggingGame';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <DiggingGame />
  </React.StrictMode>
);
